export function H2({ title, textSize }: { title: string; textSize?: string }) {
  return (
    <h2
      className={`${textSize ?? 'text-xl'} text-zinc-900 font-medium text-left`}
    >
      {title}
    </h2>
  );
}
